import type { ReactStoryblokComponent } from "types/storyblok";
import { CTABar } from "components/CTABar";
import type { CTABarProps } from "components/CTABar/CTABar.d";

const CTABarAdapter = ({ blok: { heading, buttonText }, sbEditable }: ReactStoryblokComponent<CTABarProps>) => (
  <CTABar heading={heading} buttonText={buttonText} sbEditable={sbEditable} />
);

export default CTABarAdapter;
